'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoXbox = function IoXbox(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm7.4 19.4c-3.8 5.6-3.9 10.8-3.9 11.1-2.2-2.9-3.5-6.5-3.5-10.5 0-5.2 2.3-10 6-13.2l0.3 0.1c3.9 1.4 7.2 5.3 7.2 5.3s-3 2.6-6.1 7.2z m27.6 0.6c0 4-1.3 7.6-3.5 10.5 0-0.3-0.1-5.5-3.9-11.1-3.1-4.6-6.1-7.2-6.1-7.2s3.3-3.9 7.3-5.3l0.2-0.1c3.7 3.2 6 8 6 13.2z m-21.8-13.7c-2.9-1.3-5.1-0.9-5.6-0.8 2.8-1.9 6.2-3 9.9-3s7.1 1.1 9.9 3c-0.5-0.1-2.7-0.4-5.6 0.8-2.3 1-4.3 2.8-4.3 2.8s-2-1.8-4.3-2.8z m12.3 16.6c3.2 3.8 4.3 6.6 4.9 8.4l0.1 0.4c-3.2 3.6-7.8 5.8-13 5.8s-9.8-2.2-13-5.8l0-0.4c0.7-1.8 1.8-4.6 5-8.4 3.5-4.5 8-7.4 8-7.4s4.5 2.9 8 7.4z' })
        )
    );
};

exports.default = IoXbox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/xbox.js
// module id = 3014
// module chunks = 168707334958949